import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import qs from 'qs';

/**
 * This method adds params as part of the url query string. If it already exists,
 * it replaces with new value.
 *
 * @param {String} url      The url where query string needs to be appended
 * @param {Object} params   The key value of query strings which needs to be added
 * @return {String}
 *
 * Usage:
 * addParams('https://www.jcpenney.com', { firstParam: 'test', secondParam: 'test2'})
 */
export const addParams = (url, params) => { // eslint-disable-line
    if (typeof url === 'string' && !isEmpty(params)) {
        const urlSplit = url.split('?');
        const path = urlSplit[0];
        let query = qs.parse(urlSplit[1] || '');
        forEach(params, (value, key) => {
            query = { ...query, [key]: value };
        });
        return `${path}?${qs.stringify(query, { skipNulls: true })}`;
    }
    return url;
};

export default addParams;
